export type CerteuropeSignState = {
    signingViewPending: boolean,
    signingView: null | object,
    signingViewError: null,
    pagesNumberPending: Array<number>,
    pages: Array<Page>,
    pagesError: null,
    activePage: null,
    scrollTo: null,
    signTagPendingIds: Array<number>,
    signTagError: null,
    unsignTagPendingIds: Array<number>,
    unsignTagError: null,
    validationModalIsOpen: boolean,
    sendValidationSmsPending: boolean,
    sendValidationSmsError: null,
    signDocumentPending: boolean,
    signDocumentError: null,
    resendValidationSmsPending: boolean,
    resendValidationSmsError: null,
    confirmSignaturePending: boolean,
    confirmSignatureError: null,
}

export const state: CerteuropeSignState = {
    signingViewPending: false,
    signingView: null,
    signingViewError: null,
    pagesNumberPending: [],
    pages: [],
    pagesError: null,
    activePage: null,
    scrollTo: null,
    signTagPendingIds: [],
    signTagError: null,
    unsignTagPendingIds: [],
    unsignTagError: null,
    validationModalIsOpen: false,
    sendValidationSmsPending: false,
    sendValidationSmsError: null,
    signDocumentPending: false,
    signDocumentError: null,
    resendValidationSmsPending: false,
    resendValidationSmsError: null,
    confirmSignaturePending: false,
    confirmSignatureError: null,
}
